import { createRouter, createWebHistory } from 'vue-router'

import LoginView from './pages/login'

const User = () => import('./pages/user/index.vue')
const Admin = () => import('./pages/admin/index.vue')
const Order = () => import('./pages/order/index.vue')
// const Banner = () => import('./pages/banner/index.vue')
const Settings = () => import('./pages/settings/index.vue')
const Commodity = () => import('./pages/commodity/index.vue')
const Agency = () => import('./pages/agency/index.vue')
const Application = () => import('./pages/application/index.vue')
const Wallet = () => import('./pages/wallet/index.vue')
const Crm = () => import('./pages/crm/index.vue')
const CrmDashBoard = () => import('./pages/crmDashBoard/index.vue')
const CrmSellBoard = () => import('./pages/crmSellBoard/index.vue')

const routes = [
  { path: '/', redirect: 'activity' },
  { path: '/login', name: 'login', component: LoginView },
  { path: '/admin/list', name: 'admin', component: Admin },
  { path: '/user/list', name: 'user', component: User },
  { path: '/order/list', name: 'order', component: Order },
  // { path: '/banner/list', name: 'banner', component: Banner },
  { path: '/system/settings', name: 'settings', component: Settings },
  { path: '/commodity/list', name: 'commodity', component: Commodity },
  { path: '/agency/list', name: 'agency', component: Agency },
  { path: '/application/list', name: 'application', component: Application },
  { path: '/wallet/list', name: 'wallet', component: Wallet },
  { path: '/crm/list', name: 'crm', component: Crm },
  { path: '/crm/dashBoard/list', name: 'crmDashBoard', component: CrmDashBoard },
  { path: '/crm/sellBoard/list', name: 'crmSellBoard', component: CrmSellBoard },
]

export default createRouter({
  history: createWebHistory(),
  routes,
})
